import React, { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import { api } from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { CheckCircle2, Circle, Clock } from "lucide-react";

const MODULES = ["new_hire", "annual", "critical_incident"];
const TITLES = { new_hire: "New Hire", annual: "Annual", critical_incident: "Critical" };

export default function AgencyCompletion() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/agency/completion").then(r => setRows(r.data)).catch(() => {}); }, []);

  const Cell = ({ m }) => {
    if (m?.completed_at) {
      return <CheckCircle2 className="h-4 w-4" style={{ color: "hsl(var(--haruki-leaf-deep))" }} />;
    }
    if (m?.started_at) {
      return <Clock className="h-4 w-4" style={{ color: "hsl(var(--haruki-teal))" }} />;
    }
    return <Circle className="h-4 w-4 text-muted-foreground" />;
  };

  return (
    <AdminLayout>
      <div className="haruki-fade-in">
        <h1 className="font-heading text-3xl font-bold">Completion Status</h1>
        <p className="mt-2 text-sm text-muted-foreground">Participation data only — no scores or scenario content.</p>

        <Card className="mt-8">
          <CardContent className="p-0">
            <table className="w-full text-sm">
              <thead className="border-b border-border text-left text-xs uppercase tracking-widest text-muted-foreground">
                <tr>
                  <th className="px-4 py-3">Name</th>
                  {MODULES.map(m => <th key={m} className="px-4 py-3 text-center">{TITLES[m]}</th>)}
                </tr>
              </thead>
              <tbody>
                {rows.map(r => (
                  <tr key={r.user_id} data-testid={`completion-row-${r.user_id}`} className="border-b border-border last:border-0">
                    <td className="px-4 py-3 font-medium">{r.name}</td>
                    {MODULES.map(m => (
                      <td key={m} className="px-4 py-3">
                        <div className="flex flex-col items-center gap-1">
                          <Cell m={r.modules[m]} />
                          <span className="text-xs text-muted-foreground">{r.modules[m]?.completed_at?.slice(0,10) || ""}</span>
                        </div>
                      </td>
                    ))}
                  </tr>
                ))}
                {rows.length === 0 && (
                  <tr><td colSpan={MODULES.length+1} className="px-4 py-6 text-center text-sm text-muted-foreground">No service members yet.</td></tr>
                )}
              </tbody>
            </table>
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  );
}
